import _curry2 from './_curry2.js';
import _flatCat from './_flatCat.js';
import map from '../map.js';

var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});
export default _xchain;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_xchain.js
// module id = 792
// module chunks = 2 3 4 5 6 7 8 10